import React from 'react';
import { Form, Message } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _ from 'lodash';
// import _find from 'lodash/find';

import EstaSegGral from '../../../components/funcionales/estaseggral';

//utils
import queries from '../../../utils/queries';

import general from '../../../modulos/general';

const styles1 ={
  paraH1:{
      padding: '0em',
      margin: '0em',
      color: '#302b63',
  },
  paraH2_01:{
    padding: '0em',
    margin: '0em',
    color: '#2C7744',
  },
  paraH2_02:{
      padding: '0em',
      margin: '0em',
      color: 'red',
  },
  colorRed:{
      color: 'red',
  },
  colorBlue:{
      color: '#302b63',
  },
  styPaddMarg:{
      padding: '0.2em 0.1em 0.2em 0.1em',
      fontSize: '0.9em'
  },
  styInput:{
    width: '4em',
  },
}

//dropdown CONCEPTOS
const DetalleSelCpto = props => {
  return (
    <option dato1={props.elemento.porcImpto?props.elemento.porcImpto:""} dato2={props.elemento.descrClaseServ} value={props.elemento.descrImpto?props.elemento.descrImpto:""}>{props.elemento.descrOtrosPagCl}</option>
  )
};

const ListaCpto = ({styles, handleCpto, list}) => {
  let detalleCpto = list.map((elemento, _id) => <DetalleSelCpto elemento={elemento} key={elemento._id}/>);
  return(
    <div>
      <select style={styles.input}className="ui simple selection dropdown fluid" name="cpto" id="miLista" onChange={(ev) => handleCpto(ev)}>
        <option value="">Seleccionar...</option>
        {detalleCpto}
      </select>
    </div>
  )
};
//Fin dropdown CONCEPTOS

//dropdown OFICINAS
const DetalleOf1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrOficina}</option>
  )
};

const ListaOf = ({styles, list, handleChangeOf}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleOf1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="oficina" id="miListaOf" onChange={(ev)=>handleChangeOf(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown OFICINAS

//dropdown RANGOS FACT
const DetalleRango = props => {
  let prefijo = ""
  if(props.elemento.prefijo){
    prefijo = props.elemento.prefijo
  }
  return (
    <option dato1={props.elemento._id} dato2={prefijo} value={props.elemento.proxFact}>{props.elemento.prefijo} {props.elemento.factInicial} - {props.elemento.factFinal}</option>
    // <option dato1={props.elemento._id} value={props.elemento.proxFact}>{props.elemento.factInicial} - {props.elemento.factFinal}</option>
  )
};

const ListaRango = ({styles, handleChange, list}) => {
  let detalleR = list.map((elemento, _id) => <DetalleRango elemento={elemento} key={elemento._id}/>);
  let selecc = false
  if(list.length>1){
    selecc = true
  }
  return(
    <div>
      <select style={styles.input}className="ui simple selection dropdown fluid" name="rango" id="miListaR" onChange={(ev) => handleChange(ev, list)}>
        {selecc &&
        <option value="">Seleccionar rango ...</option>
        }
        {detalleR}
      </select>
    </div>
  )
};
//Fin dropdown RANGOS FACT

class RecPagoOtr2 extends React.Component {
  state={
    argsDocumCli: {contrato: this.props.idLista.contrato,
                nombreCliente: this.props.idLista.nombreCliente,
                apellidoCliente: this.props.idLista.apellidoCliente,
                _id: this.props.idLista._id},
    argsDocum: {descrOtrosPagCl: "Seleccionar...", descrImpto: "",
                porcImpto: "", descrClaseServ: ""},
    argsAdd: {descrOficina: this.props.descrOficina, valorEf: 0, valorCh: 0, valorTr: 0, valorTC: 0, valorTD: 0},
    confirmaAct: false, open: false, listaR: []
  }

  handleCpto = (ev) => {
    const argsDocum = this.state.argsDocum
    var miLista = document.getElementById("miLista");
    if(miLista.options[miLista.selectedIndex].text!=="Seleccionar..."){
      argsDocum['descrOtrosPagCl'] = miLista.options[miLista.selectedIndex].text
      argsDocum['porcImpto'] = miLista.options[miLista.selectedIndex].attributes[0].value?miLista.options[miLista.selectedIndex].attributes[0].value:""
      argsDocum['descrImpto'] = miLista.options[miLista.selectedIndex].value?miLista.options[miLista.selectedIndex].value:""
      argsDocum['descrClaseServ'] = miLista.options[miLista.selectedIndex].attributes[1].value?miLista.options[miLista.selectedIndex].attributes[1].value:""
    }else{
      argsDocum['descrOtrosPagCl'] = "Seleccionar..."
    }
    this.setState({argsDocum});
  }

  handleChange = (ev)=>{
    // console.log(ev.target.value)
    // console.log(ev.target.name)
    const argsAdd = this.state.argsAdd
    if(ev.target.name==="rango"){
      if(ev.target.value!==""){
        var miLista = document.getElementById("miListaR");
        argsAdd['_idRango'] = miLista.options[miLista.selectedIndex].attributes[0].value
        argsAdd['prefijoFact'] = miLista.options[miLista.selectedIndex].attributes[1].value
      }else{
        argsAdd['_idRango'] = ""
        argsAdd['prefijoFact'] = ""
      }
    }else{
      argsAdd[ev.target.name] = ev.target.value
      argsAdd['contrato'] = this.props.idLista.contrato
    }
    this.setState({argsAdd, confirmaAct: false});
  }

  handleChangeOf = (ev) => {
    if(ev.target.name === "oficina"){
      const argsAdd = this.state.argsAdd
      let miLista = document.getElementById("miListaOf");
      argsAdd['descrOficina'] = miLista.options[miLista.selectedIndex].text  
      this.setState({argsAdd, confirmaAct: false});
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.allRangoFact.allRangoFact){
      if(this.state.listaR.length===0&&this.props.allRangoFact.allRangoFact.length>0){
        let listaR = this.props.allRangoFact.allRangoFact.filter(elemento => elemento.estadoRangoFact===true)
        if(this.props.idLista.cicloFact&&listaR.length>1){
          listaR = this.props.allRangoFact.allRangoFact.filter(elemento => elemento.estadoRangoFact===true&&elemento.cicloFact===this.props.idLista.cicloFact)
        }
        this.setState({listaR})
      }
      // console.log(this.state.argsAdd)
      // console.log("99", this.state.listaR)
      if(!this.state.argsAdd._idRango&&this.state.listaR.length===1&&this.state.listaR.length>0){
        const argsAdd = this.state.argsAdd
        argsAdd['_idRango'] = this.state.listaR[0]._id
        argsAdd['prefijoFact'] = this.state.listaR[0].prefijo
        // argsAdd['prefijoFact'] = this.props.prefijoFact
        this.setState({argsAdd});
      }
    }
  }

render(){
  const {argsDocumCli, argsDocum, argsAdd, confirmaAct, open, listaR} = this.state;
// console.log(this.state.argsDocumCli)
// console.log(this.props.idLista)
// console.log(this.props.list4)

let estadoCliente = this.props.idLista.estadoCliente
let saldoPendiente = this.props.idLista.saldoPendiente

let linea1DNN = ""
let linea2DNN = ""
let linea3DNN = ""
let linea4DNN = ""
let direccion1 = ""
let direccion2 = ""

if(this.props.idLista.direccion.descrTipoVia1){
  linea1DNN = `${this.props.idLista.direccion.descrTipoVia1?this.props.idLista.direccion.descrTipoVia1:""}
    ${this.props.idLista.direccion.numeroTipoVia1?this.props.idLista.direccion.numeroTipoVia1:""}
    ${this.props.idLista.direccion.descrTipoVia2?this.props.idLista.direccion.descrTipoVia2:""}
    ${this.props.idLista.direccion.numeroTipoVia2?this.props.idLista.direccion.numeroTipoVia2:""}
    ${this.props.idLista.direccion.numeroTipoVia2F?this.props.idLista.direccion.numeroTipoVia2F:""}
    ${this.props.idLista.direccion.descrTipoUnd1?this.props.idLista.direccion.descrTipoUnd1:""}
    ${this.props.idLista.direccion.numeroTipoUnd1?this.props.idLista.direccion.numeroTipoUnd1:""}
    ${this.props.idLista.direccion.descrTipoUnd2?this.props.idLista.direccion.descrTipoUnd2:""}
    ${this.props.idLista.direccion.numeroTipoUnd2?this.props.idLista.direccion.numeroTipoUnd2:""}`

    linea2DNN = `${this.props.idLista.direccion.descrTiUndMat?this.props.idLista.direccion.descrTiUndMat:""}
    ${this.props.idLista.direccion.descrUndMat?this.props.idLista.direccion.descrUndMat:""}`

    linea3DNN = `${this.props.idLista.dirmayor.descrDpto?this.props.idLista.dirmayor.descrDpto:""}
    ${this.props.idLista.dirmayor.ciudades.nombreCiudad?", " + this.props.idLista.dirmayor.ciudades.nombreCiudad:""}`

    linea4DNN = `${this.props.idLista.dirmayor.ciudades.zonas.nombreZona?", Zona: " + this.props.idLista.dirmayor.ciudades.zonas.nombreZona:""}
    ${this.props.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio?", Barrio: " + this.props.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio:""}`
  

    direccion1 = linea1DNN + ' ' + linea2DNN
    direccion2 = linea3DNN + ' ' + linea4DNN
  }

  let cptosOP = this.props.list4
  cptosOP = _.orderBy(cptosOP, ['descrOtrosPagCl'], ['asc'])

  let totRecibido = 0
  if(argsAdd.valorEf) {
    totRecibido += parseInt(argsAdd.valorEf, 10)
  }
  if(argsAdd.valorCh) {
    totRecibido += parseInt(argsAdd.valorCh, 10)
  }
  if(argsAdd.valorTr) {
    totRecibido += parseInt(argsAdd.valorTr, 10)
  }
  if(argsAdd.valorTC) {
    totRecibido += parseInt(argsAdd.valorTC, 10)
  }
  if(argsAdd.valorTD) {
    totRecibido += parseInt(argsAdd.valorTD, 10)
  }
// console.log(this.props.errors.length)

  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large hand point down yellow icon"></i>
        Cliente
      </button>
      <div>

      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <div>
          <h1 style={styles1.paraH1}>
            {argsDocumCli.contrato} - {argsDocumCli.nombreCliente} {argsDocumCli.apellidoCliente} - &nbsp;&nbsp;
            <span style={estadoCliente!=='ACTIVO'?styles1.paraH2_02:styles1.paraH2_01}>
              {estadoCliente}
            </span>
          </h1>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '65%'}}>
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  {direccion1}<br/>
                  {direccion2}
                </p>
              </div>
              <div className="column" style={{width: '35%'}}>
                <p>
                  <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                    Saldo: &nbsp;&nbsp;
                    <span style={{color: '#302b63', fontSize: '2em'}}> ${general.formatNum(saldoPendiente.toString())}</span>
                  </span>
                </p>
              </div>
            </div>
          </div>

          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsAdd, argsDocum, totRecibido, saldoPendiente, listaR, this.props.empresa):()=>{}}>
            <div>
              <hr></hr>

              <div className="ui three column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '20%'}}>
                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Recibir pago
                    </p>
                  </div>
                  <div className="column" style={{width: '30%'}}>
                    <p>
                      <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                        Total recibido: &nbsp;&nbsp;
                        <span style={{color: '#302b63', fontSize: '2em'}}> ${totRecibido}</span>
                      </span>
                    </p>
                  </div>
                  {(!this.props.descrOficina||this.props.descrOficina==="Todas...") &&
                    <div className="column" style={{width: '30%'}}>
                      <label style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold'}}>Oficina</label>
                      <Form.Field>
                        <ListaOf styles={this.props.styles} list={this.props.listaOf} handleChangeOf={this.handleChangeOf}/>
                      </Form.Field>
                    </div>
                  }

{/* El siguiente div es para que funcione otra forma de addImage en home.js en handleRecPago
                  <div id="divLogo"  className="column" style={{width: '30%'}}>

                  </div> */}
                </div>
              </div>

              <Form.Field>
                <div className="ui two column stackable grid">
                  <div className="column" style={{width: '50%'}}>
                    <label style={{color: '#302b63', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>Concepto</label>
                    <ListaCpto list={cptosOP} styles={this.props.styles} handleCpto={this.handleCpto}/>
                  </div>
                  
                  {listaR.length>1 &&
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>Rangos de facturación</label>
                      <ListaRango list={listaR} styles={this.props.styles} handleChange={this.handleChange}/>
                    </div>
                  }
                </div>
              </Form.Field>

              <div className='ui blue inverted raised segment'>
                    <div className="ui one column stackable grid">
                        <div className="row container">
                            <div className="column" width="100%">
                              <Form.Field>
                                <div className="column" style={{width: '23%'}}>
                                  <label style={this.props.styles.label}>$ Efectivo</label>
                                  <input type='number' step="1" min="0" autoFocus style={this.props.styles.input} autoComplete="off" name="valorEf" id="valorEf" placeholder='Efectivo' onChange={this.handleChange}/>
                                </div>
                              </Form.Field>
                              <Form.Field>
                                <div className="ui four column stackable grid">
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>$ Cheque</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorCh" id="valorCh" placeholder='Cheque' onChange={this.handleChange}/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}># cheque</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="numeroCh" id="numeroCh" onChange={this.handleChange} placeholder='# cheque'/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Banco</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="bancoCh" id="bancoCh" onChange={this.handleChange} placeholder='Banco'/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Fecha vencimiento</label>
                                    <input style={this.props.styles.input} type='date' name="fechaVencCh" id="fechaVencCh" onChange={this.handleChange}/>
                                  </div>
                                </div>
                              </Form.Field>
                              <Form.Field>
                                <div className="ui four column stackable grid">
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>$ Transferencia</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTr" id="valorTr" placeholder='Transferencia' onChange={this.handleChange}/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Banco</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="bancoTr" id="bancoTr" onChange={this.handleChange} placeholder='Banco'/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Fecha transferencia</label>
                                    <input style={this.props.styles.input} type='date' name="fechaTr" id="fechaTr" onChange={this.handleChange}/>
                                  </div>
                                </div>
                              </Form.Field>
                              <Form.Field>
                                <div className="ui four column stackable grid">
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>$ Tarjeta débito</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTD" id="valorTD" placeholder='Valor' onChange={this.handleChange}/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Banco</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="bancoTD" id="bancoTD" onChange={this.handleChange} placeholder='Banco'/>
                                  </div>
                                </div>
                              </Form.Field>
                              <Form.Field>
                                <div className="ui four column stackable grid">
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>$ Tarjeta crédito</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTC" id="valorTC" placeholder='Valor' onChange={this.handleChange}/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Banco</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="bancoTD" id="bancoTD" onChange={this.handleChange} placeholder='Banco'/>
                                  </div>
                                </div>
                              </Form.Field>
                            </div>
                        </div>
                    </div>
              </div>
            </div>

            <hr></hr>

            <EstaSegGral btnText='Recibir pago' open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>

            </Form>
            {
                this.props.errors.length?<Message negative header="Los siguientes errores:"
                list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
    graphql(queries.query.allRangoFact, {name:'allRangoFact', options: (props) => {return {variables: {}}}}),

    //Aunque no se necesita, se deja createCliente para mantener  la posibilidad de agregar querys
    graphql(queries.mutation.createCliente, {name:'createCliente'}),
    // graphql(queries.mutation.editCliente, {name:'editCliente'}),
    // graphql(queries.mutation.createServicio, {name:'createServicio'}),
  )(RecPagoOtr2)